import Toggle from '../lib/Toggle';
import ViewAllLess from '../lib/ViewAllLess';
import MediaQuery from '../lib/MediaQuery';

export default function v1Result() {
  const result = document.querySelector('.v1-result');
  if (!result) {
    return;
  }

  const headings = document.querySelectorAll('.v1-resultSideFilter__sideHeading');
  const toggles = document.querySelectorAll('.v1-resultSideFilter__toggle');

  const initToggle = () => {
    headings.forEach((_, index) => {
      const i = index + 1;
      const menu = new Toggle({
        triggerID: `sideFilterHeading${i}`,
        contentID: `sideFilterInner${i}`,
        showFocusElement: `#sideFilterInner${i}`,
        hideFocusElement: `#sideFilterHeading${i}`,
      });
      menu.init();
      MediaQuery.matches('lg', matches => {
        if (matches) {
          menu.show();
          menu.selector.trigger.setAttribute('tabindex', '-1');
          return;
        }
        menu.hide();
        menu.selector.trigger.removeAttribute('tabindex');
      });
    });
  };

  const initViewAll = () => {
    toggles.forEach((_, index) => {
      const i = index + 1;
      const menu = new ViewAllLess({
        triggerID: `sideFilterToggle${i}`,
        contentID: `sideFilterList${i}`,
        showFocusElement: `#sideFilterList${i}`,
        hideFocusElement: `#sideFilterToggle${i}`,
      });
      menu.init();
    });
  };

  initToggle();
  initViewAll();
}
